import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getLocalStorageValue, setLocalStorageValue } from "utils/localStorage";

const PAGE_SIDE_BAR_COLLAPSED_KEY = "pageSideBarCollapsed";

export interface PageSideBarState {
  collapsed: boolean;
}

const initialState: PageSideBarState = {
  collapsed:
    getLocalStorageValue(PAGE_SIDE_BAR_COLLAPSED_KEY) === null
      ? true
      : getLocalStorageValue(PAGE_SIDE_BAR_COLLAPSED_KEY),
};

const pageSideBarSlice = createSlice({
  name: "pageSideBar",
  initialState,
  reducers: {
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      const collapsed = action.payload;
      setLocalStorageValue(PAGE_SIDE_BAR_COLLAPSED_KEY, collapsed);
      state.collapsed = collapsed;
    },
  },
});

export const { setCollapsed } = pageSideBarSlice.actions;

export default pageSideBarSlice.reducer;
